import React from "react";

export default function slashMenu_iconComponent(icon: string) {

    const classes = Classes("flex-row-center-center ui5-ico-16 bg-palette-gray-5 border-radius-4 w-24 h-24 m-r-8", icon)

    return <div className={classes}/>
}